import { EventObject } from '@xstate/store-react';
import { StoreContext } from '../../../models/store/context';
import { AppStatus } from '../../../models/store/appStatus';
import { clearSession } from '../../../services/session/clear';
import { initialContext } from '../../initial';
import { store } from '../../store';
import { log } from '@domgen/shared/utils/log';
import { StoreEvent } from '../../../enums/storeEvent';

/**
 * Handles session expiry by clearing persisted session and resetting app state.
 *
 * Schedules creation of a new session and retains loaded catalogue while resetting
 * other runtime context to initial defaults.
 *
 * @param context Current store context.
 * @param _event Unused event payload.
 * @param enqueue Store enqueue helper used for asynchronous dispatch.
 * @returns Reset context with app loading state.
 */
export const sessionExpired = <T extends EventObject = EventObject>(
  context: StoreContext,
  _event: T,
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
  },
): StoreContext => {
  log.debug({ message: StoreEvent.SESSION_EXPIRED });
  clearSession();

  enqueue.effect(async () => {
    store.send({ type: StoreEvent.CREATE_SESSION });
  });

  return {
    ...initialContext,
    app: {
      ...initialContext.app,
      catalogue: context.app.catalogue,
      status: AppStatus.LOADING,
    },
  };
};
